module.exports = __webpack_public_path__ + "static/media/OBJECTS (2).e2aab977.svg";